import { OnboardingFlow } from "@/components/onboarding/OnboardingFlow";

export default function Onboarding() {
  return <OnboardingFlow />;
}
